import { Icon, Tooltip, Box } from "@chakra-ui/react";
import { MdSchedule } from "react-icons/md";
import { COMMS_STATUSES } from "features/Resources/Shared/constants";
import { Message } from "features/Resources/Message/models";

interface EmailMessageStatusIconProps {
  status: Message["status"]  ;
}

export default function EmailMessageStatusIcon({ status }: EmailMessageStatusIconProps) {
  const config = COMMS_STATUSES.get(status) || {
    icon: MdSchedule,
    color: "gray.400",
    label: status,
  };

  return (
    <Tooltip label={config.label} placement="top" hasArrow>
      <Box display="inline-flex" alignItems="center">
        <Icon as={config.icon} color={config.color} boxSize={5} />
      </Box>
    </Tooltip>
  );
}
